import { render, staticRenderFns } from "./CommonData.vue?vue&type=template&id=751752d6&scoped=true"
import script from "./CommonData.vue?vue&type=script&lang=ts"
export * from "./CommonData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751752d6",
  null
  
)

export default component.exports